import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import * as yup from 'yup';

import { ICredentials } from 'app/models';
// import { useMatchMedia } from 'app/hooks';
import { signin, useThunkDispatch } from 'app/state';
import { Logo } from 'app/components';
import { Button } from 'app/components/common';
import { Field, TextBox } from 'app/components/form';

import dark from 'assets/images/th-logo-dark.png';
import light from 'assets/images/th-logo-light.png';

export default memo(() => {
  const dispatch = useThunkDispatch();
  const { t } = useTranslation();

  const isDark = false; // useMatchMedia('(prefers-color-scheme: dark)');
  const [busy, setBusy] = useState(false);

  const { values, touched, errors, handleBlur, handleChange, handleReset, handleSubmit } = useFormik({
    initialValues: { username: '', password: '' } as ICredentials,
    validationSchema: yup.object({
      username: yup.string().required(),
      password: yup.string().min(6).required(),
    }),

    onSubmit: (values) => {
      setBusy(true);
      dispatch(signin(values)).finally(() => setBusy(false));
    },
  });

  return (
    <form className="w-30rem m-auto p-3 border-round surface-0 shadow-2" onSubmit={handleSubmit} onReset={handleReset}>
      <div className="py-8">
        <Logo src={isDark ? dark : light} className="w-10rem block mx-auto" />
      </div>
      <div className="p-6 pt-0">
        <div>
          <Field text={t('signin.username')} floating>
            <TextBox name="username" value={values.username} invalid={touched.username && !!errors.username} disabled={busy} onBlur={handleBlur} onChange={handleChange} />
          </Field>
        </div>
        <div className="pt-2">
          <Field text={t('signin.password')} floating>
            <TextBox type="password" name="password" value={values.password} invalid={touched.password && !!errors.password} disabled={busy} onBlur={handleBlur} onChange={handleChange} />
          </Field>
        </div>
        <div className="pt-6">
          <Button type="submit" label={t('signin.submit')} disabled={busy} className="w-full" />
        </div>
      </div>
    </form>
  );
});
